import React from "react";
import {
  FaRegClock,
  FaShieldAlt,
  FaTrashAlt,
} from "react-icons/fa";

const ITEMS = [
  {
    icon: FaShieldAlt,
    title: "Coordonnées maîtrisées",
    text: "Vous choisissez si votre email, votre téléphone ou les deux sont visibles.",
  },
  {
    icon: FaRegClock,
    title: "Durée limitée",
    text: "Les annonces expirent après six mois afin d’éviter les recherches devenues obsolètes.",
  },
  {
    icon: FaTrashAlt,
    title: "Suppression autonome",
    text: "Vous pouvez modifier ou supprimer votre annonce à tout moment.",
  },
];

export default function KataPrivacyNotice() {
  return (
    <section className="overflow-hidden rounded-[2rem] bg-slate-950 p-6 text-white sm:p-8">
      <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-300">
            Respect de vos données
          </p>

          <h2 className="mt-3 text-2xl font-semibold sm:text-3xl">
            Une publication claire et maîtrisée
          </h2>

          <p className="mt-4 text-sm leading-7 text-slate-300">
            Les informations publiées sont exclusivement
            utilisées pour permettre la mise en relation entre
            pratiquants de kata.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-3">
          {ITEMS.map((item) => {
            const Icon = item.icon;

            return (
              <article
                key={item.title}
                className="rounded-2xl border border-white/10 bg-white/5 p-4"
              >
                <Icon className="text-xl text-amber-300" />

                <h3 className="mt-3 text-sm font-semibold">
                  {item.title}
                </h3>

                <p className="mt-2 text-xs leading-5 text-slate-400">
                  {item.text}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}